import type { IStyle } from 'fela';

import type { Theme } from '../types';

export const list: IStyle = {
  justifyContent: 'center',
  marginTop: '40px'
};

export const card: (theme?: Theme) => IStyle = (theme) => ({
  display: 'flex',
  // Top aligned rather than centred, so the icons line up across a row of
  // cards whose descriptions wrap to different numbers of lines.
  alignItems: 'flex-start',
  gap: '16px',
  padding: '20px 24px',
  // Filling the grid row keeps every card in a row the same height.
  height: '100%',
  borderRadius: '16px',
  backgroundColor: '#ffffff',
  boxShadow: '0 1px 2px rgba(2, 20, 13, 0.06)',
  color: theme?.text?.style?.color ?? 'inherit',
  fontFamily: theme?.text?.font?.family ?? 'inherit',
  ':hover': {
    boxShadow: '0 4px 12px rgba(2, 20, 13, 0.12)'
  }
});

export const icon: (theme?: Theme) => IStyle = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  fontSize: '28px',
  backgroundColor: theme?.button?.style?.backgroundColor ?? '#cfff92',
  color: theme?.button?.style?.color ?? 'inherit'
});

// Topic grids mix one- and three-line descriptions, so a floor there keeps the
// rows even. Section cards are left to size to their own copy.
export const topicCard: IStyle = {
  minHeight: '132px'
};

// Section copy is short and the cards sit alone on a row, so there is nothing to
// line the icons up against and centring reads better.
export const sectionCard: IStyle = {
  alignItems: 'center'
};

export const body: IStyle = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '2px',
  minWidth: 0
};

export const title: (theme?: Theme) => IStyle = (theme) => ({
  fontSize: '1.25rem',
  lineHeight: 1.25,
  fontWeight: 'bold',
  fontFamily: theme?.header?.font?.family ?? 'inherit'
});

export const description: IStyle = {
  fontSize: '0.95rem',
  lineHeight: 1.35,
  opacity: 0.7
};

export const chevron: IStyle = {
  flexShrink: 0,
  // The chevron still reads best centred against its own card.
  alignSelf: 'center',
  opacity: 0.6
};
